import React from 'react';
import PropTypes from 'prop-types';

import { TextTitle } from '../Components/TextContent';

import ByteArkStatus from './ByteArkStatus';
import StatusList from './StatusList';

const CurrentStatus = ({ statusList, dataByteArk, loadingByteArk }) => {
  return (
    <>
      <TextTitle mt={8}>สถานะปัจจุบัน</TextTitle>
      <ByteArkStatus data={dataByteArk} loading={loadingByteArk} />
      <StatusList data={statusList} />
    </>
  );
};

CurrentStatus.propTypes = {
  statusList: PropTypes.array,
  dataByteArk: PropTypes.object,
  loadingByteArk: PropTypes.bool,
};

export default CurrentStatus;
